import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useDarkMode } from '../../contexts/DarkModeContext';

const OPTIONS = [['system', 'System', Monitor], ['light', 'Light', Sun], ['dark', 'Dark', Moon]];

/** Three-way appearance control: lives in the home footer and the profile sheet */
const AppearanceControl = ({ compact = false }) => {
  const { mode, setModeTo } = useDarkMode();
  return (
    <div className={`inline-flex gap-1 p-1 rounded-xl bg-gray-100 dark:bg-gray-900 ring-1 ring-gray-200 dark:ring-gray-600 ${compact ? '' : 'w-full'}`} role="radiogroup" aria-label="Appearance">
      {OPTIONS.map(([id, label, Icon]) => (
        <button key={id} type="button" role="radio" aria-checked={mode === id} onClick={() => setModeTo(id)} className={`${compact ? 'px-3' : 'flex-1'} inline-flex items-center justify-center gap-1.5 py-1.5 rounded-lg text-xs font-semibold transition-colors ${mode === id ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm' : 'text-gray-500 dark:text-gray-400'}`}>
          <Icon size={13} /> {label}
        </button>
      ))}
    </div>
  );
};

export default AppearanceControl;
